/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestCustomerDefaultsDto } from '../../models/harvest-customer-defaults-dto';

export interface GetDefaults_1$Params {
}

export function getDefaults_1(http: HttpClient, rootUrl: string, params?: GetDefaults_1$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestCustomerDefaultsDto>> {
  const rb = new RequestBuilder(rootUrl, getDefaults_1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestCustomerDefaultsDto>;
    })
  );
}

getDefaults_1.PATH = '/api/harvests/defaults-values';
